import React, { useEffect, useState } from 'react'
import { Title } from 'react-head'
import DefaultLayout from 'js/components/DefaultLayout'
import Header from './Header'
import TopArea from './TopArea'
import Awards from 'js/components/Awards'
import Features from './Features'
import Logo from 'js/components/Logo'
import LoginOverlay from 'js/components/Login/LoginOverlay'
import { useMatch } from 'react-router-dom'
import GympassSignup from './GympassSignup'
import LazyImage from 'js/components/LazyImage/LazyImage'
import { FormattedMessage } from 'react-intl'
import useLocale from 'js/hooks/useLocale'
import { useDispatch } from 'react-redux'
import { clearCoupon } from '../../store/pricingSlice'
import { getSessionItem } from 'js/storeManager'

export default function GympassPage() {
  const dispatch = useDispatch()
  const [showLogin, setShowLogin] = useState(false)
  const { language, setLanguage } = useLocale()
  const showSignUp = useMatch('/gympass/signup')

  const openLogin = () => {
    setShowLogin(true)
  }

  useEffect(() => {
    dispatch(clearCoupon())
  }, [dispatch])

  useEffect(() => {
    if (!language.match(/en|de|it|pt|es/)) setLanguage('en', false)
  }, [language, setLanguage])

  if (showSignUp && !getSessionItem('gympassDone')) return <GympassSignup />

  return (
    <div className="bg-Bg">
      <Title>Wellhub - Lifesum</Title>
      <DefaultLayout showInstallBanner={false}>
        <div className="mx-auto max-w-1440 px-16 md:px-20">
          <Header />
          <div
            data-testid="gympass-top-area"
            className="relative flex overflow-hidden rounded-20 bg-BgSub px-32 pb-20 pt-32 lg:pt-20"
            style={{ minHeight: 'clamp(300px, 60vh, 650px)' }}
          >
            <TopArea onLoginClick={openLogin} />
          </div>
          <div className="mx-auto my-72 max-w-1280 grid-cols-2 gap-16 text-center lg:my-96 lg:grid lg:px-80">
            <LazyImage
              src={require('./assets/mosaic.jpg')}
              className="mx-auto mb-32 w-2/3 max-w-none rounded-12 lg:mb-0 lg:w-full lg:rounded-16"
              width={650}
              height={650}
            />
            <div className="my-auto">
              <p className="mb-32 leading-body type-24 lg:mb-64 lg:type-32">
                <FormattedMessage
                  id="gympass_tagline"
                  defaultMessage="Lifesum is the digital self-care app that helps you reach your health and weight goals through better eating."
                />
              </p>
              <Awards />
            </div>
          </div>
          <Features />
          <div className="py-32 text-center lg:py-64">
            <Logo />
          </div>
        </div>
      </DefaultLayout>
      {showLogin && (
        <LoginOverlay onClose={() => setShowLogin(false)} goToAccount={false} />
      )}
    </div>
  )
}
